<template>
    <b-container fluid>
        <b-row>
            <b-col lg="8">
                <card>
                    <b-form-input v-model="filter" style="width: 250px" type="search" :placeholder="this.$t('button.search')"></b-form-input>
                    <b-table striped hover :fields="fields" :items="items" :filter="filter" @filtered="onFiltered"
                        :per-page="perPage" :current-page="currentPage" selectable select-mode="single" ref="table"
                        id="my-table">
                        <template #cell(imported)="data">
                            <b-form-checkbox :checked="data.item.imported" disabled/>
                        </template>
                    </b-table>
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="my-table">
                    </b-pagination>
                    <p class="mt-3">Current Page: {{ currentPage }}</p>
                </card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>


import importsData from '@/store/content/importsData.js'

export default {
    components: {
    },
    data() {
        return {
            filteredRows: 0,
            perPage: 4,
            currentPage: 1,
            rows: 1,
            sortable: true,
            filter: "",
            importItems: [],
        }
    },

    mounted() {
        this.rows = this.importItems.length;
    },
    beforeCreate() {
        if (!this.$store.state.importsData) this.$store.registerModule("importsData", importsData)
        this.$store.dispatch("importsData/getImportFiles")
    },
    computed: {
        fields() {
            return [
                {
                    key: "fileName",
                    label: this.$t('timetables.import_labels.fileName'),
                    sortable: true
                },
                {
                    key: "validFrom",
                    label: this.$t('timetables.import_labels.validFrom'),
                    sortable: true
                },
                {
                    key: "validUntil",
                    label: this.$t('timetables.import_labels.validUntil'),
                    sortable: true
                },
                {
                    key: "imported",
                    label: this.$t('timetables.import_labels.imported'),
                    sortable: true
                },
            ];
        },
        items() {
            var importList = this.$store.state.importsData.importsList;
            if (importList == null) {
                return [];
            }

            return importList;
        },
        totalRows() {
            return this.filter ? this.filteredRows : this.items.length;
        }
    },

    methods: {
        onFilterChange(filter) {
            this.filter = filter;
        },
        onRowSelected(items) {
            this.$emit('selectItem', items[0]);
        },
        onFiltered(filteredItems) {
            this.filteredRows = filteredItems.length;
            this.currentPage = 1;
        },
        onPageChange(selectedPage) {
            this.currentPage = selectedPage;
        }
    }
}

</script>